export const PURCHASE_LOADING = "PURCHASE_LOADING";
export const PURCHASE_RESET = "PURCHASE_RESET";
export const GET_PURCHASE = "GET_PURCHASE";
export const GET_PURCHASE_SUCCESS = "GET_PURCHASE_SUCCESS";
export const GET_PURCHASE_FAIL = "GET_PURCHASE_FAIL";
export const DELETE_PURCHASE = "DELETE_PURCHASE"
export const DELETE_PURCHASE_SUCCESS = "DELETE_PURCHASE_SUCCESS"
export const DELETE_PURCHASE_FAIL = "DELETE_PURCHASE_FAIL"
export const UPDATE_PURCHASE = "UPDATE_PURCHASE"
export const UPDATE_PURCHASE_SUCCESS = "UPDATE_PURCHASE_SUCCESS"
export const UPDATE_PURCHASE_FAIL = "UPDATE_PURCHASE_FAIL"
export const ADD_NEW_PURCHASE = "ADD_NEW_PURCHASE"
export const ADD_PURCHASE_SUCCESS = "ADD_PURCHASE_SUCCESS"
export const ADD_PURCHASE_FAIL = "ADD_PURCHASE_FAIL"